import styled from 'styled-components';

export const AboutContainer = styled.div`
  padding: 2rem;
`;

export const MissionSection = styled.section`
  margin-bottom: 3rem;
`;

export const SectionTitle = styled.h2`
  color: #003366;
  margin-bottom: 1rem;
`;

export const SectionContent = styled.div`
  line-height: 1.6;
`;

export const TeamSection = styled.section`
  margin-bottom: 3rem;
`;

export const TeamMember = styled.div`
  margin-bottom: 2rem;
  border: 1px solid #ccc;
  padding: 1rem;
  border-radius: 5px;

  h3 {
    color: #003366;
  }
`;